export function FormatDateToHuman(dateString) {
	const parts = dateString.split('/');
	const day = parts[0];
	const month = parts[1];
	const year = parts[2];
	const formattedDate = [month, day, year].join('/');
	return formattedDate;
}
